// extracted by mini-css-extract-plugin
export var alertIcon = "_vp-0";